import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "panel" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_default_transition = _resolveComponent("default-transition")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_sidebar = _resolveComponent("app-sidebar")!
  const _component_email_confirm = _resolveComponent("email-confirm")!
  const _component_empty_for_talk_me = _resolveComponent("empty-for-talk-me")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isPhone())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.mobileContainer)
        }, [
          _createVNode(_component_app_header),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.main)
          }, [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component }) => [
                _createVNode(_component_default_transition, null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      id: "content",
                      class: _normalizeClass(_ctx.$style.content)
                    }, null, 8, ["class"]))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ], 2)
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "content",
          class: _normalizeClass(_ctx.$style.desktopContainer)
        }, [
          _createVNode(_component_app_sidebar, {
            class: _normalizeClass(_ctx.$style.sidebar)
          }, null, 8, ["class"]),
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_component_default_transition, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.content)
                  }, [
                    _createVNode(_component_app_header),
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component))),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.$style.empty)
                    }, null, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.$style.footer)
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.$style.footerItem, _ctx.$style.footerLinks])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style.footerLink),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPopupVisible = true))
                        }, " Правовые документы ", 2),
                        (_ctx.isPopupVisible)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(_ctx.$style.footerPopup)
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style.footerPopupLink),
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDownloadFile(_ctx.FileName.PrivacyPolicy)))
                              }, " Политика конфиденциальности ", 2),
                              _createElementVNode("a", {
                                class: _normalizeClass(_ctx.$style.footerPopupLink),
                                href: _ctx.instructionLink,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPopupVisible = false))
                              }, " Руководство пользователя ", 10, _hoisted_1),
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style.footerPopupLink),
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDownloadFile(_ctx.FileName.FuncCharacteristics)))
                              }, " Функц. характеристики ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style.footerPopupLink),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDownloadFile(_ctx.FileName.TechSupport)))
                              }, " Тех. поддержка ", 2)
                            ], 2)), [
                              [_directive_click_outside, _ctx.onClickOutsidePopup]
                            ])
                          : _createCommentVNode("", true),
                        _createElementVNode("a", {
                          href: "https://globaltruck.ru/contacts",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: _normalizeClass(_ctx.$style.footerLink)
                        }, " Контактная информация ", 2),
                        _createElementVNode("a", {
                          href: "https://globaltruck.ru",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: _normalizeClass(_ctx.$style.footerLink)
                        }, " О компании ", 2)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.$style.footerItem, _ctx.$style.footerCopyright])
                      }, [
                        _createElementVNode("span", null, "Copyright © 2008–" + _toDisplayString(_ctx.currentYear) + " GT2™. Все права защищены.", 1)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.$style.footerItem, _ctx.$style.footerHidden])
                      }, null, 2)
                    ], 2)
                  ], 2)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          (_ctx.isShowVerifyEmail)
            ? (_openBlock(), _createBlock(_component_email_confirm, {
                key: 0,
                onClose: _ctx.onCloseModal
              }, null, 8, ["onClose"]))
            : _createCommentVNode("", true)
        ], 2)),
    (_ctx.canUseTalkMe)
      ? (_openBlock(), _createBlock(_component_empty_for_talk_me, { key: 2 }))
      : _createCommentVNode("", true),
    _hoisted_2
  ]))
}